import { generateApis } from '@lingtu/apis';
import type { ApiContainer } from '@lingtu/apis';
import { useErrorLogStoreWithOut } from '/@/store/modules/errorLog';
import { checkStatus } from '/@/utils/http/axios/checkStatus';
import { useI18n } from '/@/hooks/web/useI18n';
import { ResultEnum } from '/@/enums/httpEnum';
import { useMessage } from '/@/hooks/web/useMessage';
import { getAuthManager } from '@lingtu/user';

async function getToken() {
  const authManager = getAuthManager();
  const token = await authManager.getAccessToken();
  return token;
}
const { createMessage } = useMessage();
const result: { apiContainer: ApiContainer } = generateApis({
  getToken,
  responseCb: (data) => {
    const { t } = useI18n();
    //  这里 code，result，message为 后台统一的字段，需要在 types.ts内修改为项目自己的接口返回格式
    const { code, message } = data;

    // 这里逻辑可以根据项目进行修改
    const hasSuccess = data && Reflect.has(data, 'code') && code == ResultEnum.SUCCESS;
    if (hasSuccess) {
      return;
    }

    // 在此处根据自己项目的实际情况对不同的code执行不同的操作
    // 如果不希望中断当前请求，请return数据，否则直接抛出异常即可
    let timeoutMsg = '';
    switch (code) {
      case ResultEnum.TIMEOUT:
        timeoutMsg = '请求超时';
        break;
      default:
        if (message) {
          timeoutMsg = message;
        }
    }

    // errorMessageMode='modal'的时候会显示modal错误弹窗，而不是消息提示，用于一些比较重要的错误
    // errorMessageMode='none' 一般是调用时明确表示不希望自动弹出错误提示
    createMessage.error(timeoutMsg);
    throw new Error(timeoutMsg || t('sys.api.apiRequestFailed'));
  },
  responseCatchCb: (error: any) => {
    let isPrevent = false;
    error.preventDefault = () => {
      isPrevent = true;
    };

    setTimeout(() => {
      if (isPrevent) return;
      const errorLogStore = useErrorLogStoreWithOut();
      errorLogStore.addAjaxErrorInfo(error);
      const { response, config } = error || {};
      const errorMessageMode = config?.requestOptions?.errorMessageMode || 'message';
      const msg: string = response?.data?.error?.message ?? response?.data?.message ?? '';
      console.log(error.toString(), error?.response?.status, msg, errorMessageMode);
      checkStatus(
        error?.response?.status,
        response?.data.code,
        msg,
        errorMessageMode,
        error?.toString().includes('timeout'),
      );
    }, 0);
  },
});
export let apis = result.apiContainer;

export const initApis = () => {
  const { apiContainer, defHttp } = generateApis({
    getToken,
    responseCb: (data) => {
      const { t } = useI18n();
      //  这里 code，result，message为 后台统一的字段，需要在 types.ts内修改为项目自己的接口返回格式
      const { code, message } = data;

      // 这里逻辑可以根据项目进行修改
      const hasSuccess = data && Reflect.has(data, 'code') && code == ResultEnum.SUCCESS;
      if (hasSuccess) {
        return;
      }

      // 在此处根据自己项目的实际情况对不同的code执行不同的操作
      // 如果不希望中断当前请求，请return数据，否则直接抛出异常即可
      let timeoutMsg = '';
      switch (code) {
        case ResultEnum.TIMEOUT:
          timeoutMsg = '请求超时';
          break;
        default:
          if (message) {
            timeoutMsg = message;
          }
      }

      // errorMessageMode='modal'的时候会显示modal错误弹窗，而不是消息提示，用于一些比较重要的错误
      // errorMessageMode='none' 一般是调用时明确表示不希望自动弹出错误提示
      createMessage.error(timeoutMsg);
      throw new Error(timeoutMsg || t('sys.api.apiRequestFailed'));
    },
    responseCatchCb: (error: any) => {
      let isPrevent = false;
      error.preventDefault = () => {
        isPrevent = true;
      };

      setTimeout(() => {
        if (isPrevent) return;
        const errorLogStore = useErrorLogStoreWithOut();
        errorLogStore.addAjaxErrorInfo(error);
        const { response, config } = error || {};
        const errorMessageMode = config?.requestOptions?.errorMessageMode || 'message';
        const msg: string = response?.data?.error?.message ?? response?.data?.message ?? '';
        console.log(error.toString(), error?.response?.status, msg, errorMessageMode);
        checkStatus(
          error?.response?.status,
          response.data?.code,
          msg,
          errorMessageMode,
          error?.toString().includes('timeout'),
        );
      }, 0);
    },
  });
  apis = apiContainer;

  return {
    apis,
    defHttp,
  };
};
